import React from 'react';
import ServicePage from '../components/services/ServicePage';
import herasFencingBanners from '../data/services/heras-fencing-banners';

const HerasFencingBanners: React.FC = () => <ServicePage data={herasFencingBanners} />;

export default HerasFencingBanners;
